import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function TermosUsoPage() {
  return (
    <div className="min-h-screen bg-white relative">
      <Navbar />
      <div className="absolute top-0 left-0 right-0 h-48 md:h-64 bg-gradient-to-b from-alvinegro-black to-white z-0" />
      <main className="pt-20 md:pt-24 pb-12 relative z-10">
        <div className="w-full px-4 md:px-8">
          <Breadcrumb items={[{ label: "Início", path: "/" }, { label: "Termos de Uso" }]} />
          <div className="max-w-3xl mx-auto">
            <h1 className="font-serif font-bold text-3xl md:text-4xl text-alvinegro-black mb-8">Termos de Uso</h1>
            <div className="space-y-6">
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">1. Aceitação dos Termos</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">Ao acessar e usar o site Central Alvinegra, você concorda com estes termos de uso. Se não concordar, por favor, não utilize nossos serviços.</p>
              </section>
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">2. Uso do Site</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">O conteúdo do site é destinado a fins informativos e entretenimento. Você concorda em usar o site de forma legal e respeitosa, sem tentar comprometer sua segurança ou disponibilidade.</p>
              </section>
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">3. Conteúdo do Usuário</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">Comentários e interações devem seguir nossas diretrizes de comunidade. Proibimos conteúdo ofensivo, discriminatório, spam ou que viole direitos autorais. Reservamo-nos o direito de remover conteúdo inadequado.</p>
              </section>
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">4. Propriedade Intelectual</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">Todo o conteúdo do site é protegido por direitos autorais. Não é permitida a reprodução, distribuição ou modificação sem autorização prévia.</p>
              </section>
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">5. Isenção de Responsabilidade</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">As informações no site são fornecidas em boa fé. Não nos responsabilizamos por erros ou omissões. Decisões baseadas em nosso conteúdo são de sua responsabilidade.</p>
              </section>
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">6. Modificações</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">Podemos atualizar estes termos a qualquer momento. Alterações entram em vigor imediatamente após publicação. O uso continuado do site após modificações implica aceitação.</p>
              </section>
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">7. Lei Aplicável</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">Estes termos são regidos pelas leis da República Federativa do Brasil. Qualquer disputa será resolvida nos tribunais competentes do Rio de Janeiro.</p>
              </section>
            </div>
            <p className="text-xs text-alvinegro-muted mt-8">Última atualização: 31 de maio de 2026</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}